import { defineComponent as ne, useId as le, ref as F, useSlots as ie, computed as l, watch as C, onMounted as ue, onUnmounted as fe, createElementBlock as c, openBlock as i, normalizeClass as u, createElementVNode as m, createCommentVNode as b, unref as U, Fragment as ce, renderList as de, createBlock as pe, toDisplayString as be, renderSlot as w, nextTick as ye } from "vue";
import { isEmpty as h } from "../../utils/isEmpty.js";
import { tw as t } from "../../utils/tailwind.js";
import ve from "./components/Hint.vue2.js";
const me = ["aria-describedby", "aria-label", "aria-labelledby", "aria-valuetext"], he = ["id"], xe = ["aria-current"], we = { class: "inline-flex items-center gap-x-4" }, ke = {
  key: 1,
  class: "text-static-default-low caption"
}, ze = /* @__PURE__ */ ne({
  name: "RevStatusTracker",
  __name: "StatusTracker",
  props: {
    currentStep: {},
    orientation: { default: "horizontal" },
    progressBarColor: { default: "success" },
    steps: {},
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 }
  },
  setup(A) {
    const o = A, L = le(), z = F(null), B = F(null), k = ie();
    function x(e) {
      return o.steps.findIndex((a) => a.key === e);
    }
    function P(e) {
      if (!o.currentStep)
        return !1;
      const a = x(o.currentStep) || 0;
      return (x(e.key) || 0) < a;
    }
    function y(e) {
      return e.key === o.currentStep;
    }
    const H = l(() => !(!o.currentStep || (x(o.currentStep) || 0) === o.steps.length - 1)), q = l(() => o.orientation === "horizontal"), n = l(() => o.orientation === "vertical"), _ = t`overflow-x-hidden supports-[overflow-x:clip]:overflow-x-clip`, N = t`overflow-y-hidden supports-[overflow-y:clip]:overflow-y-clip`, j = l(() => {
      const e = t`before:border-static-default-low before:absolute before:z-[-3] before:block before:content-['']`, a = [
        t`first:before:rounded-l-full last:before:rounded-r-full`,
        t`before:inset-x-0 before:top-0 before:h-2 before:-translate-y-1/2 before:border-t-2`
      ], r = [
        t`before:rounded-full before:left-0 before:top-8 before:h-full before:w-2 before:-translate-x-1/2 before:border-l-2`,
        t`last:before:hidden`
      ];
      return n.value ? [e, r] : [e, a];
    }), K = l(() => {
      const e = t`text-static-default-hi body-2 relative`, a = [
        t`px-12 pt-18 text-center`,
        t`first:pl-0 first:text-left last:pr-0 last:text-right`
      ], r = t`flex justify-between gap-x-72 pb-24 pl-16 text-left`;
      return n.value ? [e, r] : [e, a];
    }), M = l(() => {
      const e = t`relative grid list-none`, a = t`auto-cols-fr grid-flow-col`, r = t`grid-cols-1`;
      return n.value ? [e, r] : [e, a, "overflow-wrap-anywhere"];
    }), W = l(() => {
      const e = [
        t`rounded-full absolute z-[-2]`,
        t`after:rounded-full after:absolute after:block after:transition-transform after:content-['']`
      ], a = o.progressBarColor === "success" ? t`after:border-static-success-hi` : t`after:border-static-brand-mid`, r = [
        t`-top-1 left-1 h-2 w-[calc(100%-2px)]`,
        t`after:left-0 after:top-0 after:h-2 after:w-full after:translate-x-[--progress-bar-end-x] after:border-t-2`
      ], s = [
        t`-left-1 top-8 h-full w-2`,
        t`after:-top-4 after:left-0 after:h-full after:w-2 after:translate-y-[--progress-bar-end-y] after:border-l-2 after:content-['']`
      ];
      return n.value ? [e, a, s, N] : [e, a, r, _];
    }), X = l(() => {
      const e = [
        t`rounded-full absolute z-[-2]`,
        t`after:rounded-full after:absolute after:block after:transition-transform after:content-['']`
      ], a = o.progressBarColor === "success" ? t`after:border-static-success-hi` : t`after:border-static-brand-mid`, r = [
        t`-top-1 left-1 h-2 w-[calc(100%-2px)]`,
        t`after:left-[--pulse-bar-start-x] after:top-0 after:h-2 after:w-[--pulse-bar-width] after:border-t-2`
      ], s = [
        t`-left-1 top-8 h-full w-2`,
        t`after:left-0 after:top-[--pulse-bar-start-y] after:h-[--pulse-bar-height] after:w-2 after:border-l-2 after:content-['']`
      ];
      return n.value ? [
        e,
        a,
        s,
        "after:animate-vertical-pulse",
        N
      ] : [
        e,
        a,
        r,
        "after:animate-horizontal-pulse",
        _
      ];
    }), Y = l(() => {
      const e = t`relative isolate`, a = t`mt-8`, r = t`ml-8`;
      return n.value ? [e, r] : [e, a];
    }), G = l(
      () => n.value ? t`text-right` : ""
    );
    function J(e) {
      return y(e) ? "step" : void 0;
    }
    const O = l(
      () => {
        var e;
        return (e = o.steps.find((a) => y(a))) == null ? void 0 : e.label;
      }
    );
    function $(e) {
      return `${e.key}-date`;
    }
    function I(e) {
      return `${e.key}-details`;
    }
    function g(e) {
      return `${e.key}-link`;
    }
    function Q(e) {
      const a = y(e), r = P(e), s = !y(e) && !P(e), f = t`after:rounded-full after:absolute after:z-[-1] after:block after:transition-size after:content-['']`, d = [
        t`after:left-1/2 after:top-0 after:-translate-x-1/2 after:-translate-y-1/2`,
        t`first:after:left-0 first:after:translate-x-0 last:after:left-full last:after:-translate-x-full`
      ], p = r || a ? t`after:left-0 after:top-3 after:-translate-x-1/2` : t`after:left-0 after:top-4 after:-translate-x-1/2`;
      return [
        f,
        n.value ? p : d,
        a && t`after:size-12 after:border-6`,
        r && t`after:size-10 after:border-5`,
        s && t`after:bg-surface-default-mid after:border-static-default-low after:size-10 after:border-2`,
        !s && o.progressBarColor === "success" && t`after:border-static-success-hi`,
        !s && o.progressBarColor === "accent" && t`after:border-static-brand-mid`
      ];
    }
    function Z(e) {
      return [t`line-clamp-2`, y(e) && t`body-2-bold`];
    }
    function ee(e) {
      return [y(e) && n.value && t`body-2-bold`];
    }
    const T = t`text-action-default-hi caption-link`;
    function D(e) {
      const a = x(e.key), r = B.value[a], s = r.offsetTop + 8, { offsetLeft: f, offsetWidth: d } = r;
      return a === 0 ? n.value ? s : f : a === o.steps.length - 1 ? n.value ? s : f + d : n.value ? s : f + d / 2;
    }
    async function v() {
      window.requestAnimationFrame && (await ye(), window.requestAnimationFrame(() => {
        const e = z.value;
        if (!e)
          return;
        let a = "--progress-bar-end-x", r = "--pulse-bar-start-x", s = "--pulse-bar-width";
        if (n.value && (a = "--progress-bar-end-y", r = "--pulse-bar-start-y", s = "--pulse-bar-height"), h(o.steps) || h(o.currentStep)) {
          e.style.setProperty(a, "-100%"), e.style.setProperty(r, "0"), e.style.setProperty(s, "0");
          return;
        }
        const f = x(o.currentStep), d = D(
          o.steps[f]
        );
        let p = 0, V = 0;
        if (f === o.steps.length - 1)
          p = d;
        else {
          const se = D(
            o.steps[f + 1]
          );
          p = d, V = se - p;
        }
        e.style.setProperty(
          a,
          `calc(${p}px - 100%)`
        ), e.style.setProperty(
          r,
          `${p}px`
        ), e.style.setProperty(s, `${V}px`);
      }));
    }
    function te(e) {
      return !h(e.hint);
    }
    function E(e) {
      const a = $(e);
      return !h(k[a]);
    }
    function R(e) {
      const a = I(e);
      return !h(k[a]);
    }
    function S(e) {
      const a = g(e);
      return !h(k[a]);
    }
    function re(e) {
      return E(e) || R(e) || S(e);
    }
    function ae(e) {
      return S(e) && q.value;
    }
    function oe(e) {
      return S(e) && n.value;
    }
    return C(
      () => o.currentStep,
      () => {
        v();
      }
    ), C(
      () => o.orientation,
      () => {
        v();
      }
    ), C(
      () => o.steps,
      () => {
        v();
      },
      { deep: !0 }
    ), ue(() => {
      window.addEventListener("resize", v), v();
    }), fe(() => {
      window.removeEventListener("resize", v);
    }), (e, a) => (i(), c("div", {
      ref_key: "elementRef",
      ref: z,
      class: u(Y.value)
    }, [
      m("div", {
        "aria-describedby": U(L),
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        "aria-valuetext": O.value,
        class: u(W.value),
        role: "progressbar"
      }, null, 10, me),
      m("ol", {
        id: U(L),
        class: u(M.value)
      }, [
        (i(!0), c(ce, null, de(e.steps, (r) => (i(), c("li", {
          key: r.key,
          ref_for: !0,
          ref_key: "stepRefs",
          ref: B,
          "aria-current": J(r),
          class: u([K.value, j.value, Q(r)])
        }, [
          m("div", null, [
            m("div", we, [
              m("p", {
                class: u(Z(r))
              }, be(r.label), 3),
              r.hint && te(r) ? (i(), pe(ve, {
                key: 0,
                content: r.hint
              }, null, 8, ["content"])) : b("", !0)
            ]),
            m("div", null, [
              oe(r) ? (i(), c("div", {
                key: 0,
                class: u(T)
              }, [
                w(e.$slots, g(r))
              ])) : b("", !0)
            ])
          ]),
          re(r) ? (i(), c("div", {
            key: 0,
            class: u(G.value)
          }, [
            E(r) ? (i(), c("div", {
              key: 0,
              class: u(ee(r))
            }, [
              w(e.$slots, $(r))
            ], 2)) : b("", !0),
            R(r) ? (i(), c("div", ke, [
              w(e.$slots, I(r))
            ])) : b("", !0),
            ae(r) ? (i(), c("div", {
              key: 2,
              class: u(T)
            }, [
              w(e.$slots, g(r))
            ])) : b("", !0)
          ], 2)) : b("", !0)
        ], 10, xe))), 128))
      ], 10, he),
      H.value ? (i(), c("div", {
        key: 0,
        class: u(X.value),
        role: "presentation"
      }, null, 2)) : b("", !0)
    ], 2));
  }
});
export {
  ze as default
};
